const localhost = "http://localhost:3000/api";
const webhost = "https://api.caja.zarpocomics.com/api";

export const baseUrl = process.env.NODE_ENV === "development" ? localhost : webhost;
